export default __webpack_public_path__ + "static/media/labyrinthen-floorplan-D1-D2.474e89eb.jpg";